import CREPORT from "@/constants/report";

export default {
    data() {
        return {
            VIEW_REPORT: [
                CREPORT.TYPE.SALES_TAX_SUMMARY,
                CREPORT.TYPE.ACTIVE_CLIENT_LIST,
                CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST,
                CREPORT.TYPE.INVENTORY_SUMMARY,
                CREPORT.TYPE.APPOINTMENT_BY_STATUS,
                CREPORT.TYPE.TRANSACTION_BY_PROVIDER,
                CREPORT.TYPE.ACTIVE_CLIENTS,
                CREPORT.TYPE.IN_PROCESS_MEDICAL_NOTES,
                CREPORT.TYPE.DELETED_TRANSACTIONS,
                CREPORT.TYPE.TRANSACTIONS_DETAIL,
                CREPORT.TYPE.EOD_RECONCILIATION,
                CREPORT.TYPE.SALES_BY_PROVIDER_DETAILS,
                CREPORT.TYPE.CASH_RECONCILIATION,
                CREPORT.TYPE.PROFIT_MARGIN,
                CREPORT.TYPE.SALES_BY_PROVIDER_SUMMARY,
                CREPORT.TYPE.RETURNS,
                CREPORT.TYPE.INVENTORY_ADJUSTMENTS,
                CREPORT.TYPE.INVENTORY_VALUE_COGS,
                CREPORT.TYPE.DISCOUNTS_SUMMARY,
                CREPORT.TYPE.DONATIONS_DETAILS,
                CREPORT.TYPE.FAILED_EMAILS,
                CREPORT.TYPE.ITEMS_BY_PRICE_TYPE,
                CREPORT.TYPE.AR_OUT_OF_PERIOD_SALES,
                CREPORT.TYPE.ARR,
                CREPORT.TYPE.COLLECTION_DETAILS_BY_TYPE,
                CREPORT.TYPE.CONTROLLED_SUBSTANCE_LOG,
                CREPORT.TYPE.DECLINED_ITEMS,
                CREPORT.TYPE.BILLING_DETAIL,
                CREPORT.TYPE.CARDS_STORED_ON_FILE,
                CREPORT.TYPE.OUT_OF_PERIOD_ADJUSTMENTS,
                CREPORT.TYPE.REMINDERS_DETAIL,
                CREPORT.TYPE.UNIQUE_DISPENSING_LOG,
                CREPORT.TYPE.PAYMENT_BY_PROVIDER,
                CREPORT.TYPE.INVENTORY_ALERTS,
                CREPORT.TYPE.SALES_BY_ITEM,
                CREPORT.TYPE.ACCOUNTS_RECEIVABLE,
                CREPORT.TYPE.MONTHLY_PAYMENTS_SUMMARY,
                CREPORT.TYPE.AVERAGE_CLIENT_TRANSACTION,
                CREPORT.TYPE.MONTHLY_BILLING_SUMMARY,
                CREPORT.TYPE.TIME_SHEETS,
                CREPORT.TYPE.ACTIVE_PATIENT_LIST,
                CREPORT.TYPE.CHARITABLE_FUND,
                CREPORT.TYPE.INACTIVE_PATIENT_LIST,
                CREPORT.TYPE.DECEASED_PATIENT_LIST,
                CREPORT.TYPE.NEW_PATIENTS,
                CREPORT.TYPE.RABIES_SUMMARY,
                CREPORT.TYPE.DIAGNOSIS_SUMMARY_LIST,
                CREPORT.TYPE.TOTAL_PATIENTS,
                CREPORT.TYPE.SPECIES_DISTRIBUTION,
                CREPORT.TYPE.PATIENT_BIRTHDAYS,
                CREPORT.TYPE.DISCOUNT_DETAILS,
                CREPORT.TYPE.TOTAL_BILLED_AND_COLLECTED,
                CREPORT.TYPE.INVENTORY_LOG,
                CREPORT.TYPE.SALES_BY_APPOINTMENT_TYPE,
                CREPORT.TYPE.APPOINTMENT_LOG,
                CREPORT.TYPE.CREDITS_APPLIED,
                CREPORT.TYPE.PENDING_APPOINTMENTS,
                CREPORT.TYPE.PRODUCTION_CREDIT_BY_SALES,
                CREPORT.TYPE.PRODUCTION_CREDIT_BY_PAYMENTS,
                CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT,
                CREPORT.TYPE.NEW_ENGAGED_CLIENTS,
                CREPORT.TYPE.PETCARE_CLIENT_LIST,
                CREPORT.TYPE.APPOINTMENT_DURATION,
                CREPORT.TYPE.WRITE_OFFS
            ]
        };
    },
    methods: {}
};
